export { FroalaEditorDirective } from './editor.directive';
export { FroalaEditorModule } from './editor.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-froala-wysiwyg/editor/index.js
// module id = 526
// module chunks = 4